// packages/shared-hooks/src/lead-tasks/useReopenLeadTask.ts
//
// `PATCH /lead-tasks/:id/reopen` (#2317 D-3) — restore a soft-cancelled OWN
// MANUAL task to open. Backend returns 204 and writes a `LEAD_TASK_REOPENED`
// audit row in the same tx. Invalidation matches `useCancelLeadTask` (the row
// moves back to the open list; the audit feed refreshes).
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../api/context.js';
import { leadActivityKeys } from '../lead-activity/keys.js';
import { leadTasksKeys } from './keys.js';

export function useReopenLeadTask(id: string, leadId: string) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<void, unknown, void>({
    mutationFn: () => client.patch<void>(`/lead-tasks/${id}/reopen`, undefined, {}),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: leadTasksKeys.all });
      void qc.invalidateQueries({ queryKey: leadActivityKeys.feed(leadId) });
    },
  });
}
